import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'SiftDB|Home'
          }
        }, {
          path: '/activity',
          name: 'activity',
          component: resolve => require(['@/view/Activity'], resolve),
          meta: {
            title: 'SiftDB|History'
          }
        }, {
          path: '/forum-activity',
          name: 'forum-activity',
          component: resolve => require(['@/view/ForumActivity'], resolve),
          meta: {
            title: 'SiftDB|History'
          }
        }, {
          path: '/activity-detail',
          name: 'activityDetail',
          component: resolve => require(['@/view/ActivityDetail'], resolve),
          meta: {
            title: 'SiftDB|Detail'
          }
        }, {
          path: '/activity-detail-2025',
          name: 'activityDetail2025',
          component: resolve => require(['@/view/ActivityDetail2025'], resolve),
          meta: {
            title: 'SiftDB 2025|Detail'
          }
        }, {
          path: '/activity-detail-2024',
          name: 'activityDetail2024',
          component: resolve => require(['@/view/ActivityDetail2024'], resolve),
          meta: {
            title: 'SiftDB|Detail'
          }
        }, {
          path: '/activity-detail-2023',
          name: 'activityDetail2023',
          component: resolve => require(['@/view/ActivityDetail2023'], resolve),
          meta: {
            title: 'SiftDB|Detail'
          }
        }, {
          path: '/forum-activity-detail',
          name: 'forumActivityDetail',
          component: resolve => require(['@/view/ForumActivityDetail'], resolve),
          meta: {
            title: 'SiftDB|Detail'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js